import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlListaObras = '/service/materiais/obras/'

class ConsultaObrasService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms : []
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value) : this.state.adms,
            tipo: filtro.tipo ? filtro.tipo.map(e => e.value) : '',
            natureza: filtro.natureza ? filtro.natureza.map(e => e.value) : '',
            exercicio: filtro.exercicio ? filtro.exercicio : null,
            numero: filtro.numero ? filtro.numero : null,
            descricao: filtro.descricao ? filtro.descricao : null,
            inicioInicial: filtro.inicioInicial ? moment(filtro.inicioInicial).format('YYYY-MM-DD') : '',
            inicioFinal: filtro.inicioFinal ? moment(filtro.inicioFinal).format('YYYY-MM-DD') : '',
            fimInicial: filtro.fimInicial ? moment(filtro.fimInicial).format('YYYY-MM-DD') : '',
            fimFinal: filtro.fimFinal ? moment(filtro.fimFinal).format('YYYY-MM-DD') : '',
        }
        return this.conex.post(urlListaObras + 'consultaObrasExterno/', JSON.stringify(data))
    }
}

export default ConsultaObrasService
